// Copy text to the clipboard.
//
// ⚠️ navigator.clipboard IS NOT ALWAYS THERE. Browsers expose it only in a
// SECURE CONTEXT — https, or localhost. This app's own backend is plain HTTP,
// and the desktop build is served from a plain host too, so on the deployed
// console `navigator.clipboard` is simply `undefined` and a copy button written
// against it does nothing at all, silently, only in production.
//
// So: try the modern API, fall back to the old execCommand trick, and report
// whether either worked so the caller can say "copied" honestly rather than
// hopefully.

export async function copyText(text) {
  const value = String(text ?? '');
  if (!value) return false;

  // The modern path. Also throws if the document is not focused, hence the try.
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (e) {
    // fall through to the legacy path
  }

  // Legacy path: a selected off-screen textarea. Deprecated, but it is the only
  // thing that works over plain HTTP.
  try {
    const ta = document.createElement('textarea');
    ta.value = value;
    // Off-screen rather than hidden: a display:none element cannot be selected,
    // and readOnly stops the mobile keyboard appearing.
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (e) {
    return false;
  }
}
